// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav__T1ixi","logo-wrapper":"logo-wrapper__1qmbX","logo":"logo__3mbuA"};